const FilterIcon = (props: any) => {
  return (
    <svg
      id="filter_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="35"
      viewBox="0 0 51 47"
      {...props}
    >
      <rect
        id="Rectangle_24786"
        data-name="Rectangle 24786"
        width="51"
        height="47"
        rx="5"
        fill="#0260fa"
      />
      <path
        id="filter"
        d="M.761,4.059H12.355a3.546,3.546,0,0,0,6.927,0h4.323a.761.761,0,0,0,0-1.523H19.282a3.546,3.546,0,0,0-6.926,0H.761a.761.761,0,0,0,0,1.523ZM13.8,3.3s0-.005,0-.008a2.023,2.023,0,0,1,4.046,0V3.3a2.023,2.023,0,0,1-4.046,0Zm9.81,16.535H19.282a3.546,3.546,0,0,0-6.926,0H.761a.761.761,0,0,0,0,1.523H12.355a3.546,3.546,0,0,0,6.927,0h4.323a.761.761,0,0,0,0-1.523Zm-7.787,2.784A2.025,2.025,0,0,1,13.8,20.6v0s0-.005,0-.008a2.023,2.023,0,0,1,4.046,0V20.6a2.025,2.025,0,0,1-2.023,2.02Zm7.787-11.434H12.012a3.546,3.546,0,0,0-6.927,0H.761a.761.761,0,1,0,0,1.523H5.085a3.546,3.546,0,0,0,6.926,0H23.605a.761.761,0,1,0,0-1.523Zm-13.034.759s0,.005,0,.008a2.023,2.023,0,0,1-4.046,0v-.011a2.023,2.023,0,0,1,4.046,0Z"
        transform="translate(13.317 11.248)"
        fill="#fff"
      />
    </svg>
  );
};

export default FilterIcon;
